import { extend } from 'sk-ui/lib/utils/util.js'

import desktopElementForm from './metaData/segmentSceneForm'

export default {
  segmentSceneCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: desktopElementForm,
      props
    })
  },
  segmentSceneEdit({ commit }, params) {
    const props = {
      title: '编辑云桌面元素',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, desktopElementForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  segmentSceneRelaDesktopElement({ commit }, props) {
    import('../desktopElementMng/metaData/desktopElement').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  }
}
